import 'react-app-polyfill/ie11';
import 'core-js/features/array/find';
import 'core-js/features/array/find-index';
import 'core-js/features/array/includes';
import 'core-js/features/number/is-nan';
import 'core-js/features/string/starts-with';
import 'core-js/features/string/ends-with';
import 'core-js/features/string/includes';
import 'core-js/features/object/entries';
import 'core-js/features/set';
import 'core-js/features/map';
import 'core-js/features/object';
import 'core-js/features/promise/finally';
import 'core-js/features/url-search-params';
import 'raf/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { wasPrerendered } from 'app/shared/helpers/isPrerendering';
import './index.css';

if (typeof window.IntersectionObserver === 'undefined') {
  void import('intersection-observer/intersection-observer');
}

if (
  typeof window.AbortController === 'undefined' ||
  typeof window.fetch === 'undefined'
) {
  void import('abortcontroller-polyfill/dist/polyfill-patch-fetch');
}

if ((window as Window & { Cypress?: object }).Cypress) {
  void import('storeEnvForCypress').then(({ storeEnvForCypress }) => {
    storeEnvForCypress();
  });
}

const rootElement = document.getElementById('root') as HTMLElement;

if (rootElement.children.length > 0 && wasPrerendered) {
  ReactDOM.hydrate(<App />, rootElement);
} else {
  ReactDOM.render(<App />, rootElement);
}
